import { Link } from "react-router-dom";
import { AirplaneTilt } from "@phosphor-icons/react";

// Public / pre-login header. Permanent simplification (interim public launch): the top-row action
// shortcuts (Check Price / Track / Priority Routes / Policies / Sign In) were removed — those
// functions remain reachable via each page's body/footer CTA and direct routes. Branding only.
export default function PublicHeader() {
  return (
    <header
      className="sticky top-0 z-50 bg-[hsl(var(--surface))] border-b"
      data-testid="public-header"
    >
      <div className="w-full px-8 lg:px-16 h-16 flex items-center">
        <Link to="/" className="flex items-center gap-2.5" data-testid="public-logo">
          <span className="grid place-items-center w-8 h-8 bg-[hsl(var(--foreground))] text-white rounded-[2px]">
            <AirplaneTilt size={18} weight="bold" />
          </span>
          <span className="heading text-lg tracking-tight">AIR12</span>
        </Link>
      </div>
    </header>
  );
}
